export function validateExerciseCategory(type) {
  const exercises = {
    Pushups: "pushup",
    Squats: "squat",
    "Reverse Lunges": "reverse_lunge",
    Lunge: "lunge",
    "Tricep dips": "tricep_dips",
    "Mountain Climbers": "mountain_climber",
    Burpee: "burpee",
    "Calf raises": "calf_raise",
    "Knee push-ups": "knee_push_up",
    Crunch: "crunch",
    "Glute bridge": "glute_bridge",
    "Jumping jack": "jumping_jack",
    "Leg raises": "leg_raise",
    "Step-up": "step_up",
    "Bodyweight Squat": "body_squat",
    "Bicycle crunches": "bicycle_crunch",
    "Wall sit": "wall_sit",
    "Arm Circles": "arm_circle",
    "Bear Crawl": "bear_crawl",
    "Pull-ups": "pull_up",
  };
  return exercises[type] || 0;
}

export function validateExerciseName(category) {
  const exercises = {
    pushup: "Pushups",
    squat: "Squats",
    reverse_lunge: "Reverse Lunges",
    lunge: "Lunge",
    tricep_dips: "Tricep dips",
    mountain_climber: "Mountain Climbers",
    burpee: "Burpee",
    calf_raise: "Calf raises",
    knee_push_up: "Knee push-ups",
    crunch: "Crunch",
    glute_bridge: "Glute bridge",
    jumping_jack: "Jumping jack",
    leg_raise: "Leg raises",
    step_up: "Step-up",
    body_squat: "Bodyweight Squat",
    bicycle_crunch: "Bicycle crunches",
    wall_sit: "Wall sit",
    arm_circle: "Arm Circles",
    bear_crawl: "Bear Crawl",
    pull_up: "Pull-ups",
  };
  return exercises[category] || 0;
}
